import { createContext } from "react";

export const RoutesContext = createContext();

export const routes = {home_page:"/", about_us:"/about-us",
                news:'/news', contacts: '/contacts', 
                orders: '/orders', single_news: '/single-news'}

export function RoutesProvider({children}){

    return (
        <RoutesContext.Provider value={routes}>{children}</RoutesContext.Provider>
    );
}

export default RoutesContext;